import Call from '../../Call';

const DefaultOffersCpc = {
    get() {
        return Call(`adkBanner/defaultOffersCpc`);
    },

    save(country, cpc) {
        return Call('adkBanner/defaultOffersCpc','POST', { country, cpc });
    },

    remove(country) {
        return Call(`adkBanner/defaultOffersCpc/${country}`,'DELETE');
    },
};

export default DefaultOffersCpc;


// WEBPACK FOOTER //
// ./src/services/API/components/AdkBanner/DefaultOffersCpc.js